import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import GriStandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import { TNFD_COMPLIANCE_CUSTOMIZATION } from "data/standards/griStandards";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import { TNFD_CUSTOM_FORM } from "data/forms/griFormSchema";
import { tnfdReportItems } from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import { useNavigate } from "react-router-dom";

const TnfdComplianceCustom = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const navigate = useNavigate();

  const steps = [
    "Select GRI Standards",
    "Company Information",
    "Upload Evidence",
    "Download Report",
    "Upload Evidence and Review Reports",
    "Download Gap Form",
    "Upload Gap Form",
    "Download Review Reports",
  ];

  useEffect(() => {
    if (activeStep === 4 && prevStep === 3) {
      setShowReviewPopup(true);
    }
  }, [activeStep, prevStep]);
  const handleSkipToDashboard = () => {
    setShowReviewPopup(false);
    navigate("/"); // Navigate to dashboard
  };
  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
    console.log("Standards saved:", selectedStandards);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(5);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <StandardsSelector
            standards={TNFD_COMPLIANCE_CUSTOMIZATION}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title="Select TNFD Standards from the options below"
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
          />
        );
      case 1:
        return (
          <ReusableFormComponent
            {...TNFD_CUSTOM_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 2:
        return (
          <UploadEvidenceComponent
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 3:
        return (
          <DownloadReport
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={tnfdReportItems}
            showReportCountdownButton={true}
          />
        );

      case 4:
        return (
          <UploadEvidenceReviewReports
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 5:
        return (
          <DownloadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 6:
        return (
          <UploadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 7:
        return (
          <DownloadPostReviewReports
            onPrevious={handleBack}
            standardName="TNFD"
            showReportCountdownButton={true}
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="TNFD"
                title={"TNFD Reporting"}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              mb: 2,
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToDashboard}
      />
    </>
  );
};

export default TnfdComplianceCustom;
